import { createNativeStackNavigator, NativeStackNavigationOptions } from "@react-navigation/native-stack";
import { getStateFromPath } from "@react-navigation/native";
import ActivitiesScreen from "../ActivitiesScreen";
import ActivityReviewScreen from "../ActivityReviewScreen";
import ActivityReviewListScreen from "../ActivityReviewListScreen";
import ActivityScreen from "../ActivityScreen";
import MyActivityGroup from "../MyActivity";
import { RootStackParamList } from "../types";
import ActivityRequestPointsScreen from "../ActivityRequestPointsScreen";

import JobDetailScreen from "../JobDetailScreen";
import JobApplyScreen from "../JobApplyScreen";
import ApplicationSubmittedScreen from "../JobApplyScreen/ApplicationSubmittedScreen";
import JobPreferencesScreen from "../JobPreferencesScreen";
import { ScreenOptionsFnProps } from "../../components/HeaderBackButton";

export const Stack = createNativeStackNavigator<RootStackParamList>();

export type RootStack = typeof Stack;

export type ResultState = Extract<ReturnType<typeof getStateFromPath>, Object>;

type ScreenOptions =
  | NativeStackNavigationOptions
  | ((props: ScreenOptionsFnProps<RootStackParamList>) => NativeStackNavigationOptions);

export function ActivitiesScreens(screenOptions: ScreenOptions) {
  return (
    <Stack.Group screenOptions={screenOptions}>
      <Stack.Screen name="Activities" component={ActivitiesScreen} options={{ title: "Browse Activities" }} />
      <Stack.Screen name="Activity" component={ActivityScreen} options={{ title: "" }} />
      <Stack.Screen
        name="ActivityRequestPoints"
        component={ActivityRequestPointsScreen}
        options={{ title: "Request Points" }}
      />
      <Stack.Screen name="ActivityReview" component={ActivityReviewScreen} options={{ title: "Activity Review Request" }} />
      {MyActivityGroup(Stack)}

      <Stack.Screen
        name="ActivityReviewList"
        component={ActivityReviewListScreen}
        options={{ title: "Activity Review Requests" }}
      />
    </Stack.Group>
  );
}

export function JobScreens(screenOptions: ScreenOptions) {
  return (
    <Stack.Group screenOptions={screenOptions}>
      <Stack.Screen name="JobDetail" component={JobDetailScreen} options={{ title: "Job Details" }} />
      <Stack.Screen name="JobApply" component={JobApplyScreen} options={{ title: "Apply" }} />

      <Stack.Screen name="JobApplySuccess" component={ApplicationSubmittedScreen} options={{ headerShown: false }} />
      <Stack.Screen name="JobPreferences" component={JobPreferencesScreen} options={{ title: "Job Preferences" }} />
    </Stack.Group>
  );
}
